import React from 'react';
import { Github, Activity } from 'lucide-react';
import { SOCIAL_LINKS } from '../data/constants';

const TickerBanner: React.FC = () => {
    // Find the github URL safely
    const githubUrl = SOCIAL_LINKS.find(link => link.name.toLowerCase() === 'github')?.url || 'https://github.com/ArvindPadala';

    const renderMessage = (key: number) => (
        <div key={key} className="mx-4 flex items-center gap-2">
            <Activity size={14} className="text-green-500 animate-pulse" />
            <span>I'm currently updating the codebase! For more details on new projects and articles, please visit my</span>
            <a
                href={githubUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 font-semibold hover:text-primary transition-colors underline underline-offset-2"
            >
                <Github size={14} /> GitHub Profile
            </a>
            <span className="mx-4 text-muted-foreground">•</span>
        </div>
    );

    return (
        <div className="w-full bg-accent/30 border-b border-border overflow-hidden whitespace-nowrap text-xs text-foreground py-2 flex items-center">
            <div className="animate-ticker flex w-max hover:[animation-play-state:paused] cursor-default">
                {/* 
                  Render multiple identical messages to ensure seamless infinite looping.
                  Since we animate to -50% translateX, we need at least 2 full screens of content.
                */}
                {[...Array(6)].map((_, i) => renderMessage(i))}
            </div>
        </div>
    );
};

export default TickerBanner;
